import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

const ImagePreview = ({ src, label, isLoading }) => {
    const [scale, setScale] = useState(1);
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [startDrag, setStartDrag] = useState({ x: 0, y: 0 });
    const containerRef = useRef(null);

    const handleWheel = (e) => {
        e.preventDefault();
        const delta = e.deltaY > 0 ? 0.9 : 1.1;
        const newScale = Math.min(Math.max(scale * delta, 0.1), 10);
        
        // Zoom towards mouse position
        const rect = containerRef.current.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        // Calculate new offset to keep the point under the mouse
        const newOffsetX = mouseX - (mouseX - offset.x) * (newScale / scale);
        const newOffsetY = mouseY - (mouseY - offset.y) * (newScale / scale);

        setScale(newScale);
        setOffset({ x: newOffsetX, y: newOffsetY });
    };

    const handleMouseDown = (e) => {
        if (e.button === 2) { // Right click
            setIsDragging(true);
            setStartDrag({ x: e.clientX - offset.x, y: e.clientY - offset.y });
        }
    };

    const handleMouseMove = (e) => {
        if (isDragging) {
            setOffset({
                x: e.clientX - startDrag.x,
                y: e.clientY - startDrag.y
            });
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleContextMenu = (e) => {
        e.preventDefault();
    };

    return (
        <Box 
            ref={containerRef}
            onWheel={handleWheel}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onContextMenu={handleContextMenu}
            sx={{ 
                flex: 1, 
                border: '1px solid #ddd', 
                borderRadius: 1, 
                position: 'relative', 
                overflow: 'hidden', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                bgcolor: '#fafafa',
                cursor: isDragging ? 'grabbing' : 'default',
                userSelect: 'none'
            }}
        >
            <Typography variant="overline" sx={{ position: 'absolute', top: 5, left: 10, zIndex: 2, bgcolor: 'rgba(255,255,255,0.7)', px: 0.5, borderRadius: 0.5 }}>
                {label}
            </Typography>
            
            {isLoading && (
                <Box sx={{ position: 'absolute', zIndex: 3, bgcolor: 'rgba(255,255,255,0.7)', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CircularProgress size={30} />
                </Box>
            )}

            {src ? (
                <Box
                    sx={{
                        transform: `translate(${offset.x}px, ${offset.y}px) scale(${scale})`,
                        transition: isDragging ? 'none' : 'transform 0.1s ease-out',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%'
                    }}
                >
                    <img 
                        src={src} 
                        alt={label} 
                        style={{ 
                            maxWidth: '100%', 
                            maxHeight: '100%', 
                            objectFit: 'contain',
                            pointerEvents: 'none'
                        }} 
                    />
                </Box>
            ) : (
                <Typography color="text.secondary">No image</Typography>
            )}
        </Box>
    );
};

export default ImagePreview;
